import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center mt-3"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Prev ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-left ml-3" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right mr-3" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Next ")

import { AuthModule } from "@/store/modules/Auth";
import { TicketModule } from "@/store/modules/Ticket";
import { ITicketView } from "@/types/tickets";
import { computed, ref, watch } from "vue";
import { MessageModule } from "@/store/modules/Message";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const numTicketsDisplayed = 5;
const actualPage = ref(1);
const tickets = computed(() => TicketModule.LastTicketsFromClient);
const totalPages = computed(
	() => TicketModule.LastTicketsPagination.totalPages
);
const currentPages = computed(() =>
	Math.ceil(tickets.value.length / numTicketsDisplayed)
);
const ticketsDisplayed = computed<ITicketView[]>(() =>
	tickets.value.slice(
		actualPage.value * numTicketsDisplayed - numTicketsDisplayed,
		actualPage.value * numTicketsDisplayed
	)
);

const getMessages = async (ticketId: string) => {
	if (
		!AuthModule.token ||
		(ticketId === TicketModule.currentRoomID &&
			MessageModule.getMessages.length)
	)
		return;
	TicketModule.previewOldTicket({ ticketId: ticketId });
};

async function paginate(page: number) {
	const client = TicketModule.currentRoom?.users[0]._id + "";
	if (currentPages.value < page)
		await MessageModule.requestTicketsFromClient({
			token: AuthModule.token ?? "",
			client,
			page,
		});
	actualPage.value = page;
}

watch(
	() => [TicketModule.currentRoomID],
	() => {
		if (TicketModule.currentRoomID === TicketModule.currentNewestRoom.id)
			actualPage.value = 1;
	}
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticketsDisplayed), (ticket) => {
      return (_openBlock(), _createElementBlock("div", {
        key: ticket._id,
        class: "row d-flex justify-content-center mb-2"
      }, [
        _createVNode(_component_el_button, {
          class: "col-11 last-ticket",
          type: ticket.color,
          onClick: ($event: any) => (getMessages(ticket._id)),
          round: "",
          plain: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(`${ticket.interface} button-icon`)
            }, null, 2),
            _createElementVNode("div", _hoisted_1, _toDisplayString(ticket.createdAt), 1)
          ]),
          _: 2
        }, 1032, ["type", "onClick"])
      ]))
    }), 128)),
    (_unref(totalPages) > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            disabled: actualPage.value === 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (paginate(actualPage.value - 1))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            disabled: actualPage.value === _unref(totalPages),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (paginate(actualPage.value + 1))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})